/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shadows_DisableInputs */

const en_shadows_disable = /** @type {(inputs: Shadows_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disable shadows`)
};

const fr_shadows_disable = /** @type {(inputs: Shadows_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactiver les ombres`)
};

const ms_sg2_shadows_disable = /** @type {(inputs: Shadows_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyahaktifkan bayang`)
};

/**
* | output |
* | --- |
* | "Disable shadows" |
*
* @param {Shadows_DisableInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const shadows_disable = /** @type {((inputs?: Shadows_DisableInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shadows_DisableInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shadows_disable(inputs)
	if (locale === "fr") return fr_shadows_disable(inputs)
	return ms_sg2_shadows_disable(inputs)
});